export default "__VITE_ASSET__BVLI7w25__"